module.exports = " <div class=c-off-canvas-wrap :style=\"{overflow: isOpen ? 'hidden' : false}\"> <div class=c-off-canvas-wrap__content :style=\"{transform: contentTransform}\"> <slot></slot> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OffCanvasWrap.vue
 ** module id = 142
 ** module chunks = 1
 **/